import React from "react"
import PropTypes from "prop-types"
import { Box } from "@material-ui/core"
import IdGenerator from "../../../../IdGenerator"
import Separator from "./Separator"

// Sonar lists 'Component' as unused. This is a false positive and is fixed in Sonar 8.5.
export default function HorizontalLayout({
  data,
  Component,
  HorizontalLayoutProps,
  ...rest
}) {
  const generator = new IdGenerator()
  const { exactSplit, responsive, ...horizontalLayoutProps } =
    HorizontalLayoutProps

  return (
    <Box
      name="Layout"
      className="dashboard-widget-layout"
      display="flex"
      justifyContent="space-between"
      {...horizontalLayoutProps}
    >
      {data.items.map((item, id) => (
        /*
         * This is required because no info on the item is actually unique, a
         * layout could have twice the same item and this item would have to
         * appear twice
         */
        <React.Fragment key={generator.getId(item)}>
          {id !== 0 && (
            <Separator className="dashboard-widget-layout-vertical-separator" />
          )}
          <Box
            name="LayoutItem"
            className="dashboard-widget-layout-item"
            style={{ width: "100%" }}
          >
            <Component
              {...rest}
              data={item}
              advancedOptions={data.advancedOptions}
              title={rest.title || data.title || item.title}
            />
          </Box>
        </React.Fragment>
      ))}
    </Box>
  )
}

HorizontalLayout.propTypes = {
  data: PropTypes.object.isRequired,
  HorizontalLayoutProps: PropTypes.object,
  // Required to avoid cyclic dependency with DashboardElement
  Component: PropTypes.func.isRequired
}

HorizontalLayout.defaultProps = {
  HorizontalLayoutProps: {}
}
